module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product) ? _c('div', {
    staticClass: "clearfix mxn2 flex"
  }, [_c('div', {
    staticClass: "col col-4 px2"
  }, [_c('div', {
    staticClass: "card sh1"
  }, [(_vm.product.pictures.length > 0) ? _c('div', {
    staticClass: "p1"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainPicture.href,
      "data-lightbox": "image-1",
      "data-title": _vm.mainPicture.title
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mainPicture.href
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pictures clearfix mt2 mxn1 flex justify-center"
  }, _vm._l((_vm.extraPictures), function(picture, index) {
    return _c('div', {
      staticClass: "col col-3 px1",
      class: {
        active: index === _vm.selectedPicture
      }
    }, [_c('a', {
      attrs: {
        "href": picture.href,
        "data-lightbox": "image-1",
        "data-title": picture.title
      }
    }, [_c('img', {
      attrs: {
        "src": picture.href
      }
    })])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p3"
  }, [_c('div', {
    staticClass: "bold fz18 mb2"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.long_description)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col col-8 px2"
  }, [_c('div', {
    staticClass: "bg-white rounded sh1"
  }, [_c('div', {
    staticClass: "clearfix p3"
  }, [_c('div', {
    staticClass: "col col-7 border-right border-light-grey pr3"
  }, [_c('div', {
    staticClass: "bold fz18 mb2"
  }, [_vm._v("Tilpass produktet")]), _vm._v(" "), _c('myo-parameters', {
    ref: "parameters",
    attrs: {
      "type": _vm.product.slug
    },
    on: {
      "loaded": _vm.onParametersLoaded,
      "changed": _vm.onParametersChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-5 pl3"
  }, [_c('div', {
    staticClass: "bold fz18 mb2"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix flex"
  }, [_c('div', {
    staticClass: "col col-6"
  }, [_c('div', {
    staticClass: "fz24 light mb1"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.unitPrice)) + ",-")]), _vm._v(" "), _c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Pr. stk.")])]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 right-align"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-blue"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.price)) + ",-")]), _vm._v(" "), _c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Totalpris inkl. MVA")])])]), _vm._v(" "), _c('div', [_c('myo-input', {
    staticClass: "myo-input-block my2 center",
    attrs: {
      "type": "number",
      "disabled": !_vm.parametersLoaded
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', [_c('md-button', {
    staticClass: "md-raised md-primary btn-block",
    nativeOn: {
      "click": function($event) {
        _vm.buy()
      }
    }
  }, [_vm._v("Kjøp")])], 1)])])]), _vm._v(" "), (_vm.product.accessories.length > 0) ? _c('div', {
    staticClass: "card sh1 mt3",
    attrs: {
      "id": "accessories"
    }
  }, [_c('div', {
    staticClass: "bold fz18 p3 b border-bottom border-light-grey"
  }, [_vm._v("Tilbehør")]), _vm._v(" "), _c('table', {
    staticClass: "full-width mt1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.product.accessories), function(accessory, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "p2 cell-image"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(accessory),
        "width": "100",
        "height": "100"
      },
      on: {
        "click": function($event) {
          _vm.viewProduct(accessory.id)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "px2"
    }, [_c('div', {
      staticClass: "fz16 mb1 text-blue pointer",
      on: {
        "click": function($event) {
          _vm.viewProduct(accessory.id)
        }
      }
    }, [_vm._v(_vm._s(accessory.name) + "\n              ")]), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(accessory.short_description) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "px2"
    }, [_c('div', {
      staticClass: "fz24 light mb1 text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(accessory.from_price)) + ",-")]), _vm._v(" "), _c('small', {
      staticClass: "text-grey"
    }, [_vm._v("Pr. stk.")])]), _vm._v(" "), _c('td', {
      staticClass: "px2 cell-quantity"
    }, [_c('myo-input', {
      staticClass: "myo-input-block my2 center",
      model: {
        value: (accessory.quantity),
        callback: function($$v) {
          _vm.$set(accessory, "quantity", $$v)
        },
        expression: "accessory.quantity"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "px2 center"
    }, [_c('md-button', {
      staticClass: "md-raised md-primary",
      nativeOn: {
        "click": function($event) {
          _vm.buyAccesory(accessory)
        }
      }
    }, [_vm._v("Kjøp")])], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.product.related.length > 0) ? _c('div', {
    staticClass: "card sh1 mt3",
    attrs: {
      "id": "related"
    }
  }, [_c('div', {
    staticClass: "bold fz18 p3 b border-bottom border-light-grey"
  }, [_vm._v("Relaterte produkter")]), _vm._v(" "), _c('table', {
    staticClass: "full-width mt1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.product.related), function(related, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "p2 cell-image"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(related),
        "width": "100",
        "height": "100"
      },
      on: {
        "click": function($event) {
          _vm.viewProduct(related.id)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "px2"
    }, [_c('div', {
      staticClass: "fz16 mb1 text-blue pointer",
      on: {
        "click": function($event) {
          _vm.viewProduct(related.id)
        }
      }
    }, [_vm._v(_vm._s(related.name) + "\n              ")]), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(related.short_description) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "px2"
    }, [_c('div', {
      staticClass: "fz24 light mb1 text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(related.from_price)) + ",-")]), _vm._v(" "), _c('small', {
      staticClass: "text-grey"
    }, [_vm._v("Pr. stk.")])]), _vm._v(" "), _c('td', {
      staticClass: "px2 center"
    }, [_c('md-button', {
      staticClass: "md-raised md-primary",
      nativeOn: {
        "click": function($event) {
          _vm.viewProduct(related.id)
        }
      }
    }, [_vm._v("Kjøp")])], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.product.templates.length > 0) ? _c('div', {
    staticClass: "card sh1 mt3",
    attrs: {
      "id": "templates",
      "md-label": "Maler"
    }
  }, [_c('div', {
    staticClass: "bold fz18 p3 b border-bottom border-light-grey"
  }, [_vm._v("Maler og manualer")]), _vm._v(" "), _c('table', {
    staticClass: "full-width mt1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.product.templates), function(template, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_vm._m(3, true), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey p2"
    }, [_c('a', {
      staticClass: "fz16 mb1 text-blue pointer",
      attrs: {
        "href": template.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(template.title))]), _vm._v(" "), _c('div', {
      staticClass: "text-grey mt1"
    }, [_vm._v("\n                " + _vm._s(template.original_filename) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey px2 center"
    }, [_c('a', {
      attrs: {
        "href": template.href,
        "target": "_blank"
      }
    }, [_c('md-button', {
      staticClass: "md-raised md-primary"
    }, [_vm._v("Last ned")])], 1)])])
  }))])]) : _vm._e()])]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-grey px2 py1 left-align",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1 left-align"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1"
  }, [_vm._v("Kjøp")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-grey px2 py1 left-align",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1 left-align"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1"
  }, [_vm._v("Kjøp")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-grey px2 py1 left-align",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Fil")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1"
  }, [_vm._v("Last ned")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "border-bottom border-light-grey p2",
    staticStyle: {
      "width": "70px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/ui/blank-file.svg",
      "width": "50",
      "height": "50"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d8fd079","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/shop/Product.vue
// module id = 641
// module chunks = 1